<template>
  <div class="home home-p-color min-container">
    <div class="banner min-container">
      <div class="container">
        <div class="topbackground">
          <img src="/pc/static/img/hom/bg.png">
        </div>
        <swiper
          ref="swiperOption"
          :options="swiperOption">
         <swiper-slide class="slider-img" v-for="(item, i) in items" :key="i" >
            <div class="slide_info">
                <p class="title">HOW TO BUY</p>
                <p class="subtitle" style="font-weight:100;">{{item.subtitle}}</p>
            </div>
            <img class="image" :src="item.src">
         </swiper-slide>
        <div
          slot="pagination"
          class="swiper-pagination"
        />
        <div
          slot="button-prev"
          class="swiper-button-prev"
        />
        <div
          slot="button-next"
          class="swiper-button-next"
        />
        </swiper>
      </div>
    </div>
    <div class="poker min-container">
      <div class="container">

        <div class="title center">
          <div class="title_bg"></div>
          <p>GAME ITEMS</p>
        </div>

        <div class="poker-con">
          <div class="center">
            <div class="poker-item"  @click="toShop(1)">
              <img class="diamond" src="/pc/static/img/hom/Diamonds.png" />
              <p style="line-height:75px">100 UNITS</p>
              <div class="normal">
                  <p >$1.66</p>
              </div>
            </div>
            <div class="poker-item"  @click="toShop(2)">
             <img class="diamond" src="/pc/static/img/hom/Diamonds2.png" />
             <p style="line-height:40px">1K UNITS</p>
              <div class="normal">
                  <p>$16.55</p>
              </div>
            </div>
            <div class="poker-item" @click="toShop(3)">
              <img class="diamond" src="/pc/static/img/hom/Diamonds3.png" />
              <p style="line-height:50px">5K UNITS</p>
                <div class="normal">
                    <p>$77</p>
                </div>
            </div>
            <div class=" poker-item" @click="toShop(4)">
              <img class="diamond" src="/pc/static/img/hom/Diamonds4.png" />
              <p style="line-height:50px">10K UNITS</p>
                <div class="normal">
                    <p>$150</p>
                </div>
            </div>
          </div>
          <div class="center">
            <div class="poker-item" @click="toShop(5)">
              <img class="diamond" style="margin-top: 35px;" src="/pc/static/img/hom/Diamonds5.png" />
              <p style="line-height: 55px">50K UNITS</p>
                <div class="normal" >
                    <p >$729</p>
                </div>
            </div>
            <div class="poker-item" @click="toShop(6)">
             <img class="diamond" style="margin-top: 30px;" src="/pc/static/img/hom/Diamonds6.png" />
              <p style="line-height: 40px">100K UNITS</p>
                <div class="normal">
                    <p >$1418</p>
                </div>
            </div>
            <div class="poker-item-large" @click="toShop(7)">
             <img class="diamond" style="margin-top: 30px;" src="/pc/static/img/hom/Diamonds7.png" />
              <p style="line-height: 45px">300K UNITS</p>
                <div class="normal">
                    <p >$4254</p>
                </div>
            </div>
          </div>
          <div>
            <p class="title_diamond" style="font-size:14px; text-align:center;">
              Playing on a third-party gaming platform is for entertainment purposes only, with no possibility for cash or other real-world value to be earned or withdrawn in any form.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="background-div"></div>

    <div class="club min-container">
      <div class="container">
        <div class="title center">
          <div class="title_bg"></div>
          <p>WHY YOU SHOULD CHOOSE US</p>
        </div>
        <div class="club_item" style="margin-top: 96px;">
          <img class="club_item_img" src="/pc/static/img/hom/LowestPricesOnline.png" />
          <div class="item_content">
            <p class="title_p">Lowest Prices Online</p>
            <p style="padding-top:30px">Findchip strives to provide our customers with the lowest prices anywhere on the internet for game items.</p>
          </div>
           <img class="club_item_img_right" src="/pc/static/img/hom/MultiplePaymentMethods.png" />
          <div class="item_content_right">
            <p class="title_p">Multiple Payment Methods</p>
            <p style="padding-top:30px">Findchip offers players a variety of payment options including credit card, debit card and E-wallet.</p>
          </div>
        </div>
        <div class="club_item">
          <img class="club_item_img" src="/pc/static/img/hom/InstantAccess.png" />
          <div class="item_content">
            <p class="title_p">Instant Access</p>
            <p style="padding-top:30px">Game items will be credited to your in-app mailbox automatically within minutes after completing payment.</p>
          </div>
          <img class="club_item_img_right" src="/pc/static/img/hom/SecureOrdering.png" />
          <div class="item_content_right" style="top:100px">
            <p class="title_p">Secure Ordering</p>
            <p style="padding-top:30px">All orders on Findchip are processed securely.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="background-div"></div> -->

  </div>
</template>

<script>
// @ is an alias to /src
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      style: {},
      items: [
        {
          src: '/pc/static/img/hom/topbanner1.png',
          subtitle: 'Select the Game Items that you want to purchase.'
        },
        {
          src: '/pc/static/img/hom/topbanner2.png',
          subtitle: 'Pay for your Game Items with a credit card, debit card or E-wallet.'
        },
        {
          src: '/pc/static/img/hom/topbanner3.png',
          subtitle: 'Game items will be credited to your in-app mailbox automatically after payment is complete.'
        }
      ],
      swiperOption: {
        // slidesPerView: 1,
        // slidesPerColumn: 1,
        spaceBetween: 2,
        // width:1300,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created () {
    this.$store.commit('changeTab', '/home')
    // this.initData()
    // this.PC_VERSON = PC_VERSON
    // this.FB_VERSON = FB_VERSON
    this.style = {
      backgroundImage: "url('/pc/static/img/hom/top_pro.png')"
    }
  },
  methods: {
    toShop (parse) {
      window.location.href = '/shop' + '?parse=' + parse
    }
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 0px 0px 0px 0px;
  // margin-top: -91px;
  .banner {
    position: relative;
    height: 766px;
    width: 100%;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-image: url('/pc/static/img/hom/bg2.jpg');
    overflow: hidden;
    .topbackground {
      position:relative;
      height: 749px;
      width: 100%;
      img {
        position: absolute;
        top: 0px;
        right: -240px;
        width: 86%;
        height: 100%;
      }
    }
    .swiper-container {
      position: relative;
      top:-730px;
      left:-160px;
      width:1500px;
      height:700px;
    }
    .swiper-button-prev {
      background: url("/pc/static/img/hom/prev_button.png") no-repeat center
        center;
      padding: 20px;
      background-size: 32px;
    }
    .swiper-button-next {
      background: url("/pc/static/img/hom/next_button.png") no-repeat center
        center;
      padding: 20px;
      background-size: 32px;
    }
    .swiper-pagination {
      bottom: 50px;
      z-index: 5;
      /deep/.swiper-pagination-bullet {
        width: 18px;
        height: 18px;
        margin: 0 20px;
        background-color:transparent;
        border: 3px #00fd95 solid;
      }
      /deep/.swiper-pagination-bullet-active {
        background: #00fd95;
      }
    }
    .slider-img {
      position: relative;
      top:150px;
      left:180px;
      display: flex;
      background-size:auto 100%;
      height: 600px;
      width: 1000px;
    }
    .image {
      position: relative;
      width:500px;
      height:450px;
      bottom:20px;
      left:50px;
      background-size:auto 100%;
      flex-shrink: 0;
    }
    .silde_info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .title {
      position: relative;
      width: 600px;
      text-align: center;
      margin: 0px;
      height: 70px;
      left:-50px;
      top: 90px;
      font-size:68px;
      font-weight:bold;
      color:#ffffff;
    }
    .subtitle {
      position: relative;
      width: 400px;
      text-align: left;
      margin: 0px;
      height: 70px;
      top: 130px;
      left: 35px;
      font-size:18px;
      font-weight: 100;
      color:#ffffff;
    }
    .el-carousel {
      width:1300px;
      left: -400px;
      top:100px;
      text-align:center;
      .el-carousel__item {
        .image {
          position: relative;
          left:180px;
          width:500px;
          height:450px;
          bottom:130px;
          background-size:auto 100%;
        }
        .title {
          position: relative;
          width: 600px;
          text-align: center;
          margin: 0px;
          height: 70px;
          top: 90px;
          font-size:68px;
          font-weight:bold;
          color:#ffffff;
        }
        .subtitle {
          position: relative;
          width: 400px;
          text-align: left;
          margin: 0px;
          height: 70px;
          top: 130px;
          left: 85px;
          font-size:18px;
          color:#ffffff;
        }
      }
    }
    .banner_img {
      display: block;
      width: 100%;
      height: 772px;
      background-position: center top;
      background-repeat: no-repeat;
      background-size: auto 100%;
    }
    .buy_easy {
      position: absolute;
      width: 360px;
      margin-left: -180px;
      height: 70px;
      left: 50%;
      top: 90px;
      .buy_easy_bg {
        position: absolute;
        width: 100%;
        height: 50%;
        top: 50%;
        left: 0px;
        background-color: #01483b;
      }
      p {
        line-height: 70px;
        font-size: 48px;
        font-weight: 700;
        position: relative;
        text-align: center;
        color: #ffffff;
      }
    }
    .banner_body {
      position: absolute;
      left: 50%;
      margin-left: -590px;
      top: 330px;
      width: 1180px;
      height: 250px;
      text-align: center;
      .banner_body_item {
        width: 33.33%;
        height: 100%;
        display: inline-block;
        vertical-align: top;
        .item_title {
          font-size: 24px;
          color: #ffffff;
          font-weight: 700;
          margin-bottom: 30px;
        }
        p {
          padding: 0px 40px;
          color: #ffffff;
        }
      }
    }
  }
  .poker {
    background-color: #eaffef;
    position: relative;
    padding: 80px 0px 0px 0px;
    .title_p {
      font-size:16.5px;
      line-height: 50px;
      color: #141a38;
      padding:10px;
      text-align: center;
    }
    .title {
      font-size: 60px;
      line-height: 50px;
      font-weight: 600;
      color: #0C5217;
      position: absolute;
      width: 360px;
      margin-left: -180px;
      height: 70px;
      left: 50%;
      top: 90px;
      img {
        display: inline-block;
        margin: 0px 10px;
      }
      .title_bg {
        position: absolute;
        width: 100%;
        height: 50%;
        top: 50%;
        left: 0px;
        background-color: #6cff8b;
      }
      p {
        line-height: 70px;
        font-size: 48px;
        font-weight: 700;
        position: relative;
      }
    }
    .poker-con {
      padding: 90px 0px 50px 0px;
      margin-top:20px;
      .center {
        display: flex;
        justify-content: space-between;
      }
      .poker-item {
        position: relative;
        width: 295px;
        height: 295px;
        display: inline-block;
        justify-content: space-between;
        margin-bottom: 80px;
        text-align: center;
        cursor: pointer;
        background-image: url('/pc/static/img/hom/payment1_1_pro.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        &:hover {
          background-image: url('/pc/static/img/hom/payment1_2_pro.png');
        }
      }
      .poker-item-large {
        position: relative;
        width: 592px;
        height: 295px;
        display: inline-block;
        justify-content: space-between;
        margin-bottom: 80px;
        text-align: center;
        cursor: pointer;
        background-image: url('/pc/static/img/hom/payment1_3_pro.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        &:hover {
          background-image: url('/pc/static/img/hom/payment1_4_pro.png');
        }
      }
      h3 {
        font-size: 48px;
        margin: 60px 10px 0px 0px;;
        line-height: 40px;
        font-weight: 700;
        color: #ff4200;
      }
      .diamond {
        color: #656565;
        line-height: 60px;
        text-align: center;
        margin-top: 50px;
      }
      p {
        font-size: 24px;
        line-height:50px;
        color: #036555;
      }
      .line-through {
        text-decoration: line-through;
      }
      .normal {
        position: absolute;
        width: 100%;
        height: 74px;
        bottom: 0px;
        text-align: center;
        p {
          line-height: 60px;
          font-weight:500;
          font-size: 36px;
          color: #FFCC00;

          img {
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      .title_diamond {
        font-size: 12px;
        color: #656565;
        text-align: center;
        margin-left:10px;
      }
    }
  }

  .background-div {
    position: relative;
    width: 100%;
    height: 20px;
    background-color: #8ad49c;
  }

  .club {
    position: relative;
    background-color: #eaffef;
    padding: 80px 0px 90px 0px;
    background-image: url(/pc/static/img/hom/diwen.png);
    background-repeat: no-repeat;
    background-size:100% auto;
    background-position:bottom center;
    .title {
      font-size: 60px;
      line-height: 50px;
      font-weight: 600;
      color: #0C5217;
      position: absolute;
      width: 750px;
      margin-left: -370px;
      height: 70px;
      left: 50%;
      top: 70px;
      img {
        display: inline-block;
        margin: 0px 10px;
      }
      .title_bg {
        position: absolute;
        width: 100%;
        height: 50%;
        top: 50%;
        left: 0px;
        background-color: #6cff8b;
      }
      p {
        line-height: 70px;
        font-size: 48px;
        font-weight: 700;
        position: relative;
      }
    }
    .club_item {
      position: relative;
      display:inline-block;
      width: 100%;
      height: 280px;
      margin: 0px 20px;
      .club_item_img {
        position: absolute;
        display: inline-block;
        width: 580px;
        height: 280px;
        left: 0px;
        top: 0px;

      }
      .item_content {
        position: absolute;
        top:80px;
        left:145px;
        width:390px;
        height:150px;
        .title_p {
          font-size: 24px;
          color: #656565;
          font-weight: 700;
        }
        p {

          font-size: 16px;
          color: #656565;
        }
      }
      .club_item_img_right {
        position: relative;
        display:inline-block;
        width: 580px;
        height: 280px;
        left: 50%;
        top: 0px;
      }
      .item_content_right {
        position: absolute;
        top:90px;
        left:62%;
        width:390px;
        height:150px;
        .title_p {
          font-size: 24px;
          color: #656565;
          font-weight: 700;
        }
        p {
          font-size: 16px;
          color: #656565;
        }
      }
    }
  }
}
</style>
